<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="750px">
      <v-card grid-list-md>
        <ModelTitle title="New Grade" @close="close()" />

        <v-card-text>
          <v-container grid-list-lg fill-height fluid>
            <v-layout align-center justify-center fill-height>
              <v-flex shrink>
                <v-card outlined max-width="750px">
                  <v-stepper vertical v-model="step" class="elevation-0">
                    <v-stepper-step :complete="step > 1" step="1">
                      Select Class Room
                    </v-stepper-step>
                    <v-stepper-content step="1">
                      <v-card-text>
                        <v-row class="mt-2">
                          <v-col cols="12">
                            <v-autocomplete
                              :loading="classRoomLoading"
                              item-text="name"
                              return-object
                              v-model="selectedClassRoom"
                              outlined
                              :hide-details="classRoomErrors.length === 0"
                              dense
                              :error-messages="classRoomErrors"
                              :items="classRooms"
                              label="Select Class Room"
                            >
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="text--primary text-capitalize"
                                    v-text="item.name"
                                  >
                                  </v-list-item-title>
                                  <v-list-item-subtitle
                                    class="caption"
                                    v-text="item.Class.name"
                                    v-if="item.Class"
                                  ></v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="classRoomDone" color="primary" large
                          >next</v-btn
                        >
                      </v-card-actions>
                    </v-stepper-content>

                    <v-stepper-step :complete="step > 2" step="2">
                      Select Year
                    </v-stepper-step>
                    <v-stepper-content step="2">
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <div v-if="selectedYear">
                              Department Room: {{ selectedClassRoom.name }}
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              :loading="yearLoading"
                              item-text="name"
                              return-object
                              single-line
                              v-model="selectedYear"
                              outlined
                              :hide-details="yearErrors.length === 0"
                              dense
                              :error-messages="yearErrors"
                              :items="years"
                              label="Select Year"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-btn large text @click="step = step - 1">Back</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn @click="yearDone" color="primary" large="large"
                          >Next</v-btn
                        >
                      </v-card-actions>
                    </v-stepper-content>

                    <v-stepper-step :complete="step > 3" step="3">
                      Select Term
                    </v-stepper-step>
                    <v-stepper-content step="3">
                      <v-card-text>
                        <v-row class="mt-2">
                          <v-col cols="12" sm="12">
                            <v-layout row wrap>
                              <v-flex shrink>
                                <div v-if="selectedYear">
                                  Year: {{ selectedYear.name }}
                                </div>
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex shrink>
                                <div
                                  v-if="selectedClassRoom"
                                  class="text-right"
                                >
                                  Class Room: {{ selectedClassRoom.name }}
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              :loading="termLoading"
                              item-text="name"
                              return-object
                              single-line
                              v-model="selectedTerm"
                              outlined
                              :hide-details="termErrors.length === 0"
                              dense
                              :error-messages="termErrors"
                              :items="terms"
                              label="Select Term"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-btn large text @click="step = step - 1">Back</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn @click="termDone" color="primary" large="large"
                          >Next</v-btn
                        >
                      </v-card-actions>
                    </v-stepper-content>

                    <v-stepper-step :complete="step > 4" step="4">
                      Generate Grade
                    </v-stepper-step>
                    <v-stepper-content step="4">
                      <v-card-actions>
                        <v-btn
                          text
                          v-if="gradeFound"
                          :loading="curriculumLoading"
                          @click="fetchCurriculum"
                          >Fetch Subject</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="selectedStudent"
                          text
                          @click="openTermComment"
                          >Add Term Comment</v-btn
                        >
                      </v-card-actions>
                      <v-card-text>
                        <v-row class="mt-2">
                          <v-col cols="12" sm="12">
                            <v-layout row wrap>
                              <v-flex shrink>
                                <div v-if="selectedYear">
                                  Year: {{ selectedYear.name }}
                                </div>
                                <div v-if="selectedTerm">
                                  Term: {{ selectedTerm.name }}
                                </div>
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex shrink>
                                <div
                                  v-if="selectedClassRoom"
                                  class="text-right"
                                >
                                  Class Room: {{ selectedClassRoom.name }}
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              :loading="studentLoading"
                              item-text="fullName"
                              return-object
                              single-line
                              v-model="selectedStudent"
                              outlined
                              :hide-details="studentErrors.length === 0"
                              dense
                              :error-messages="studentErrors"
                              @change="getSubjects"
                              :items="students"
                              label="Select Student"
                            ></v-autocomplete>
                          </v-col>
                          <v-col>
                            <v-list dense>
                              <template v-for="(row, index) in subjects">
                                <v-list-item :key="index">
                                  <v-list-item-content>
                                    <v-list-item-title
                                      v-if="row.create"
                                      class="text-capitalize"
                                      >{{ row.name }}</v-list-item-title
                                    >
                                    <v-list-item-title
                                      v-else
                                      class="text-capitalize"
                                      >{{ row.Subject.name }}</v-list-item-title
                                    >
                                  </v-list-item-content>
                                  <v-list-item-content>
                                    <v-text-field
                                      hide-details
                                      outlined
                                      autofocus
                                      type="number"
                                      class="right-input"
                                      dense
                                      suffix="/100"
                                      v-model="row.ObtainedMarks"
                                      label="Marks"
                                    ></v-text-field>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-list>
                          </v-col>
                        </v-row>
                        <span v-if="gradeCreated"
                          >Grade has been updated, if no more grades to add
                          close the window</span
                        >
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-btn large text @click="step = step - 1">Back</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          :loading="loading"
                          @click="submit"
                          color="primary"
                          large
                          >save</v-btn
                        >
                      </v-card-actions>
                    </v-stepper-content>
                  </v-stepper>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="termCommentDialog" persistent max-width="400px">
      <v-card grid-list-md>
        <ModelTitle title="Term Comment" @close="closeTermComment()" />
        <v-card-text>
          <v-textarea
            v-model="TermComment.comment"
            label="Comment"
            dense
            outlined
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="closeTermComment()"
            >Close</v-btn
          >
          <v-btn
            color="primary"
            :loading="loading"
            dark
            @click="saveTermComment()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gradeService from "../service.js";
import studentService from "@/modules/Student/service.js";
import termService from "@/modules/ReportCard/Terms/service.js";
import termCommentService from "@/modules/ReportCard/TermComments/service.js";
import subjectService from "@/modules/ReportCard/Subject/service.js";
import yearService from "@/modules/ReportCard/Year/service.js";
import classRoomService from "@/modules/ClassRoom/service.js";
// import curriculumService from "@/modules/ReportCard/Curriculums/service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-grade",
  props: {
    createDialog: {
      default: false,
    },
  },
  data() {
    return {
      step: 1,
      yearId: null,
      years: [],
      yearLoading: false,
      selectedYear: null,
      terms: [],
      termLoading: false,
      selectedTerm: null,
      classRooms: [],
      classRoomLoading: false,
      selectedClassRoom: null,
      subjects: [],
      studentLoading: false,
      selectedStudent: null,
      gradeCreated: false,
      students: [],
      gradeFound: false,
      loading: false,
      dialog: false,
      curriculumLoading: false,
      termCommentDialog: false,
      termCommentFound: false,
      Grade: {
        title: null,
        totalMarks: 100,
        ObtainedMarks: 0,
        StudentId: null,
        TermId: null,
        SubjectId: null,
        ClassRoomId: null,
      },
      TermComment: {
        comment: null,
        TermId: null,
        StudentId: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    yearId: {
      required,
    },
    Grade: {
      totalMarks: {
        required,
      },
      TermId: {
        required,
      },
      StudentId: {
        required,
      },
      ClassRoomId: {
        required,
      },
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
      if (val) {
        this.getClassrooms();
      }
    },
    selectedYear(val) {
      if (val) {
        this.yearId = val.id;
      }
    },
    selectedTerm(val) {
      if (val) {
        (this.Grade.TermId = val.id), (this.TermComment.TermId = val.id);
      }
    },
    selectedClassRoom(val) {
      if (val) {
        this.Grade.ClassRoomId = val.id;
      }
    },
    selectedStudent(val) {
      if (val) {
        (this.Grade.StudentId = val.id), (this.TermComment.StudentId = val.id);
      }
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    yearErrors() {
      const errors = [];
      if (!this.$v.yearId.$dirty) return errors;
      if (!this.$v.yearId.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    totalMarksErrors() {
      const errors = [];
      if (!this.$v.Grade.totalMarks.$dirty) return errors;
      if (!this.$v.Grade.totalMarks.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    termErrors() {
      const errors = [];
      if (!this.$v.Grade.TermId.$dirty) return errors;
      if (!this.$v.Grade.TermId.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    studentErrors() {
      const errors = [];
      if (!this.$v.Grade.StudentId.$dirty) return errors;
      if (!this.$v.Grade.StudentId.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    classRoomErrors() {
      const errors = [];
      if (!this.$v.Grade.ClassRoomId.$dirty) return errors;
      if (!this.$v.Grade.ClassRoomId.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  methods: {
    getYear() {
      this.yearLoading = true;
      yearService
        .getAll({ ClassId: this.selectedClassRoom.ClassId })
        .then((response) => {
          this.yearLoading = false;
          this.years = response.data;
        })
        .catch((error) => {
          console.log("error getting years", error);
          this.yearLoading = false;
        });
    },
    async getSubjects(val) {
      this.gradeCreated = false;
      if (val) {
        this.Grade.ObtainedMarks = 0;
        this.gradeFound = false;
        await gradeService
          .getAll({
            TermId: this.selectedTerm.id,
            StudentId: val.id,
            ClassroomId: this.selectedClassRoom.id,
          })
          .then((response) => {
            console.log("gradeFound response", response);
            this.subjects = response.data;
            if (this.subjects.length) {
              this.gradeFound = true;
            }
          })
          .catch((error) => {
            console.log("error getting grade", error);
          });
        if (!this.gradeFound) {
          if (
            this.selectedClassRoom.Curriculum &&
            this.selectedClassRoom.Curriculum.subjectMeta &&
            this.selectedClassRoom.Curriculum.subjectMeta.subjects
          ) {
            let subjectId = [];
            this.selectedClassRoom.Curriculum.subjectMeta.subjects.map(
              (sub) => {
                subjectId.push(sub.id);
              }
            );
            subjectService
              .getAll({ filteredSubjects: subjectId })
              .then((response) => {
                this.subjects = response.data;
                this.subjects.map((row) => {
                  row.ObtainedMarks = 0;
                  row.create = true;
                });
              })
              .catch((error) => {
                console.log("error getting subjects", error);
              });
          }
        }
      }
    },
    async fetchCurriculum() {
      this.curriculumLoading = true;
      if (
        this.selectedClassRoom.Curriculum &&
        this.selectedClassRoom.Curriculum.subjectMeta &&
        this.selectedClassRoom.Curriculum.subjectMeta.subjects
      ) {
        let subjectId = this.selectedClassRoom.Curriculum.subjectMeta.subjects
          .filter(
            (sub) =>
              !this.subjects.some((subject) => subject.SubjectId === sub.id)
          )
          .map((sub) => sub.id);
        if (subjectId.length) {
          return subjectService
            .getAll({ filteredSubjects: subjectId })
            .then((response) => {
              this.subjects = [];
              response.data.map((row) => {
                row.ObtainedMarks = 0;
                row.create = true;
              });
              this.subjects = this.subjects.concat(response.data);
              this.curriculumLoading = false;
              this.gradeFound = false;
              return response;
            })
            .catch((error) => {
              this.curriculumLoading = false;
              console.log("error getting subjects", error);
            });
        } else {
          this.curriculumLoading = false;
          this.gradeFound = false;
        }
      } else {
        this.curriculumLoading = false;
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "No new subjects",
          });
      }
    },
    getTerms() {
      this.termLoading = true;
      termService
        .getAll({ YearId: this.yearId })
        .then((response) => {
          this.termLoading = false;
          this.terms = response.data;
        })
        .catch((error) => {
          this.termLoading = false;
          console.log("error getting terms", error);
        });
    },
    getStudents() {
      this.studentLoading = true;
      studentService
        .getAll({ ClassRoomId: this.selectedClassRoom.id })
        .then((response) => {
          this.students = response.data;
          // console.log("getting students", this.students);
        })
        .catch((error) => {
          console.log("error getting students", error);
        });
      this.studentLoading = false;
    },
    getClassrooms() {
      this.classRoomLoading = true;
      classRoomService
        .getAll()
        .then((response) => {
          console.log("get class room", response);
          this.classRoomLoading = false;
          this.classRooms = response.data.sort((a, b) => {
            const nameA = (a.name || "").toLowerCase();
            const nameB = (b.name || "").toLowerCase();
            return nameA.localeCompare(nameB);
          });
        })
        .catch((error) => {
          this.classRoomLoading = false;
          console.log("error getting classRooms", error);
        });
    },
    yearDone() {
      this.$v.yearId.$touch();
      if (this.$v.yearId.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.Grade.TermId = null;
        this.TermComment.TermId = null;
        this.selectedTerm = null;
        this.getTerms();
        this.step = 3;
      }
    },
    termDone() {
      this.$v.yearId.$touch();
      this.$v.Grade.TermId.$touch();
      if (this.$v.yearId.$invalid || this.$v.Grade.TermId.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.selectedStudent = null;
        this.Grade.StudentId = null;
        this.getStudents();
        this.step = 4;
      }
    },
    classRoomDone() {
      this.$v.Grade.ClassRoomId.$touch();

      if (this.$v.Grade.ClassRoomId.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
        return;
      }

      // 🚫 Block if no curriculum assigned
      if (!this.selectedClassRoom || !this.selectedClassRoom.CurriculumId) {
        this.$swal.fire({
          icon: "warning",
          title: "No Curriculum Assigned",
          text: "This classroom does not have a curriculum assigned. Please go back, assign a curriculum to this classroom, and then come back to create grades.",
          confirmButtonText: "OK",
        });
        return;
      }

      this.selectedYear = null;
      this.YearId = null;
      this.getYear();
      this.step = 2;
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    clearStudentData() {
      this.Grade.ObtainedMarks = 0;
      this.subjects = [];
      this.Grade.StudentId = null;
      this.TermComment.comment = null;
      this.TermComment.StudentId = null;
      (this.selectedStudent = null), (this.gradeFound = false);
      this.$v.$reset();
    },
    empty() {
      this.Grade = {
        title: null,
        totalMarks: 100,
        ObtainedMarks: 0,
        StudentId: null,
        TermId: null,
        SubjectId: null,
        ClassRoomId: null,
      };
      (this.TermComment = {
        comment: null,
        TermId: null,
        StudentId: null,
      }),
        (this.selectedYear = null),
        (this.selectedClassRoom = null),
        (this.selectedStudent = null),
        (this.selectedTerm = null),
        (this.yearId = null),
        (this.step = 1),
        this.$v.$reset();
    },
    closeTermComment() {
      (this.termCommentFound = false),
        (this.TermComment = {
          comment: null,
          TermId: null,
          StudentId: null,
        }),
        (this.termCommentDialog = false);
    },
    saveTermComment() {
      this.termCommentDialog = false;
    },
    openTermComment() {
      return termCommentService
        .getAll({
          TermId: this.TermComment.TermId,
          StudentId: this.TermComment.StudentId,
        })
        .then((response) => {
          if (response.data.length) {
            this.termCommentFound = true;
            this.TermComment = response.data[0];
          } else {
            this.termCommentFound = false;
          }
          this.termCommentDialog = true;
        })
        .catch((error) => {
          console.log("error getting term comments", error);
        });
    },
    async submit() {
      await this.createTermComment();
      await this.saveGrade();
    },
    saveGrade() {
      this.loading = true;
      this.Grade.subjectList = this.subjects;
      return gradeService
        .saveMultipleGrades(this.Grade)
        .then((result) => {
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Grade is saved",
              });
          }
          this.loading = false;
          this.$emit("submit");
          this.gradeCreated = true;
          this.clearStudentData();
        })
        .catch((err) => {
          console.log("err", err);
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },
    createTermComment() {
      this.loading = true;
      if (!this.termCommentFound) {
        return termCommentService
          .create(this.TermComment)
          .then((result) => {
            console.log("result ", result);
          })
          .catch((err) => {
            console.log("err", err);
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      } else {
        return termCommentService
          .update(this.TermComment.id, this.TermComment)
          .then((result) => {
            console.log("result ", result);
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
